import React from 'react';
import { Card, Icon, Typography, tokens } from '@vp/swan';
import styled from 'styled-components';
import { __ } from '@99designs/i18n';
import { OptionsDialog } from '../OptionsDialog';

const IconWrapper = styled.div`
    position: absolute;
    top: ${tokens.SwanSemSpace4};
    right: ${tokens.SwanSemSpace4};
    z-index: 1;
`;

const RelativeCard = styled(Card)`
    cursor: pointer;
    background-color: ${tokens.SwanBaseColorGrey100};
    position: relative;
`;

export function CompareOptions() {
    const [isOpen, setIsOpen] = React.useState(false);
    return (
        <>
            <RelativeCard onClick={() => setIsOpen(!isOpen)}>
                <Typography fontSkin="body-standard-bold" mb={4}>
                    {__('A way of working that works for you')}
                </Typography>
                <Typography>
                    {__('Choose the review option that best suits your way of working.')}
                </Typography>
                <Typography>{__('Click here to compare options.')}</Typography>
                <IconWrapper>
                    <Icon iconType="plus" size="24p" />
                </IconWrapper>
            </RelativeCard>
            <OptionsDialog isOpen={isOpen} setIsOpen={setIsOpen} />
        </>
    );
}
